module.exports = __webpack_public_path__ + "img/snow.02151024.png";